import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import waterfall from 'vue-waterfall2'
import { VueMasonryPlugin } from 'vue-masonry';
import scroll from 'vue-seamless-scroll'
Vue.use(VueMasonryPlugin);
Vue.use(waterfall)
Vue.use(scroll)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios


// 动态修改页面标题title
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
